<template>
    <div class="limited-time-offer-editor">
        <label>{{ $t('whatsapp_business_api.limitedTimeOfferLabel') }} <span class="required">*</span></label>
        <p class="description" style="margin-bottom: 12px;">
            {{ $t('whatsapp_business_api.ltoDescription') }}
        </p>
        <a-input
            :value="data.text"
            @input="updateText"
            :placeholder="$t('whatsapp_business_api.ltoPlaceholder')"
            :maxLength="60"
            style="margin-bottom: 12px;"
        />
        <span class="char-count">{{ (data.text || "").length }}/60</span>
        <div class="lto-expiration-toggle">
            <a-checkbox :checked="data.hasExpiration" @change="updateHasExpiration">
                {{ $t('whatsapp_business_api.showExpirationTimer') }}
            </a-checkbox>
            <span class="hint-text">
                {{ $t('whatsapp_business_api.ltoExpirationHint') }}
            </span>
        </div>
    </div>
</template>

<script>
import Vue from "vue";


export default Vue.extend({
    name: "LimitedTimeOfferEditor",
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    methods: {
        updateText(e) {
            this.$emit('update', { ...this.data, text: e.target.value });
        },
        updateHasExpiration(e) {
            this.$emit('update', { ...this.data, hasExpiration: e.target.checked });
        },
    },
});
</script>

<style scoped lang="scss">
.limited-time-offer-editor {
    background: #fffbf0;
    border: 1px solid #ffe58f;
    border-radius: 8px;
    padding: 16px;

    label {
        display: block;
        margin-bottom: 8px;
        font-weight: 500;

        .required {
            color: #ff4d4f;
        }
    }

    .description {
        color: #666;
        font-size: 14px;
    }

    .char-count {
        font-size: 12px;
        color: #999;
        display: block;
    }

    .lto-expiration-toggle {
        margin-top: 12px;
        padding: 12px;
        background: white;
        border-radius: 6px;
        border: 1px solid #e8e8e8;

        .ant-checkbox-wrapper {
            display: flex;
            align-items: flex-start;
            margin-bottom: 8px;
        }

        .hint-text {
            display: block;
            margin-left: 24px;
            font-size: 12px;
            color: #666;
            line-height: 1.5;
        }
    }
}
</style>
